"use strict";

import React from "react";
import modal from "../modal";

module.exports = (utils = window.flex) => {
    const { uuid } = utils;

    const Modal = modal(utils);

    const WithModal = (WrappedComponent) => (class extends React.Component {
        constructor(...args) {
            super(...args);
            this.state = {
                content: undefined,
                props: {},
                id: uuid()
            };
        }

        closeModal = (...args) => {
            let onClose = this.state.props.onClose;
            this.setState({
                content: undefined,
                props: {}
            });
            if (typeof (onClose) === 'function') {
                onClose(...args);
            }
        };

        showModal = (content, props) => {
            this.setState({ content, props });
        };

        render() {
            const {
                content: modalContent,
                props: modalProps,
                id
            } = this.state;
            const { display } = this.props;

            let { onClose, ...newModalProps } = modalProps;

            let modal = !!modalContent && <Modal {...newModalProps} id={id} onClose={this.closeModal}>
                {modalContent}
            </Modal>;

            if (display === 'inline') {
                return (
                    <span>
                        <WrappedComponent {...this.props} showModal={this.showModal} closeModal={this.closeModal} />
                        {modal}
                    </span>
                );
            }

            return <div>
                <WrappedComponent {...this.props} showModal={this.showModal} closeModal={this.closeModal} />
                {modal}
            </div>
        }
    });

    return WithModal;
};